export const checkMission = (missionConfigId) => {
  const storedMissions = localStorage.getItem('missions')

  if (!storedMissions) {
    console.error('No mission data found in localStorage')
    return
  }

  const parsedMissions = JSON.parse(storedMissions)
  const mission = parsedMissions.data.find((mission) => mission.missionConfigId === missionConfigId)

  if (!mission) {
    console.error('Mission not found')
    return
  }

  // Check if the mission's status is "Go"
  if (mission.missionStatus === 'Go') {
    // Update the mission status to "claim"
    mission.missionStatus = 'Claim'

    // Store the updated mission status in localStorage
    localStorage.setItem('missions', JSON.stringify(parsedMissions))

    console.log(`Mission ${missionConfigId} status updated to "claim"`)
  } else {
    console.log('Mission is not in progress or already completed.')
  }
}
